import FormFieldController from "confinus_ui/forms/form_field_controller";

export default class TextFieldController extends FormFieldController {
  public static targets = ["leadingTextAddOn", "trailingTextAddOn"];

  declare protected readonly leadingTextAddOnTarget: HTMLSpanElement;
  declare protected readonly trailingTextAddOnTarget: HTMLSpanElement;
}
